import ProductDescription from './ProductDescription'

const TofuProduct = {
  ...ProductDescription,
  category: '02',
  subCategory: '004',
  IsBroadband: false,
  Calcium: '',
  IsPlainRefrigerated: false,
  Texture: '',
  OtherTexture: null,
  PackageSize: '',
  Organic: false,
}

export default TofuProduct
